module.exports = __webpack_public_path__ + "img/iphone.c4c7b284.png";